<div class="column"
    [ngClass]="{'col-12 col-md-3 col-lg-3 col-xl-3': size==1, 'col-mbl-big col-md-6 col-lg-6 col-xl-6': size==2, 'col-mbl-big col-md-12 col-lg-12 col-xl-12': size==3}">
    <div [id]="kpiId" class="card"
        [ngClass]="{ 'card-more': isMoreHost, 'card-progressbar': hostsMultiProgress, 'card-chart-donut': hostsDoughnutChart, 'card-charts': hostsLineChart || hostsBarChart, 'card-table': hostsTable}">
        <div class="card-loading" [hidden]="!refreshing">
            <div class="spinner">
                <div class="bounce1"></div>
                <div class="bounce2"></div>
                <div class="bounce3"></div>
            </div>
        </div>
        <div class="card-header">
            <ng-content select="[icon]"></ng-content>
            <span ngbTooltip="{{tooltip}}">{{title}}</span>
            <div id="{{kpiMenuId}}" #cardMenu class="dropdown" ngbDropdown (click)="$event.stopPropagation()">
                <a class="dropdown-toggle dropdown-toggle-more" role="button" id="dropdownMenuLink" ngbDropdownToggle aria-haspopup="true" aria-expanded="false"
                    [hidden]="!hasMenu">
                    <i class="ico-dots"></i>
                </a>
                <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="dropdownMenuLink">
                    <ng-content select="[menuOption]"></ng-content>
                </div>
            </div>
        </div>
        <div #cardBody class="card-body"
            [ngClass]="{'card-body-alert': warn, 'card-body-twocolumn': isTwoColumn}"
            (click)="bodyClick($event)">
            @if (lastUpdatedText && lastUpdatedText!='' && !refreshing) {
              <div class="rs-update">
                <span class="rs-update-num">{{lastUpdatedText}}</span>
                <i class="material-icons">refresh</i>
              </div>
            }

            <div style="display: none">
                <ng-content select="[sink]"></ng-content>
            </div>
            <ng-content select="[errorMsg]"></ng-content>
            <div #mainDataHost
                [hidden]="!showMainDataHost"
                class="rs-card-data">
                <ng-content select="[mainData]"></ng-content>
            </div>
            <ng-content select="[additionalData]"></ng-content>
        </div>
        <ng-content select="[detailDialog]"></ng-content>
    </div>
</div>
